@if (editMode) {
  <div></div>
}

@if (!editMode) {
  <div>
    <div class="message-bubble">
      <div class="message-text">
        {{ messageText }}
      </div>
    </div>
    <!-- div class="arrow"></div -->
  </div>
}
